module.exports = __webpack_public_path__ + "static/img-hero--massgeschneidert-a840191c2a8020c59555ced94cb93d69.png";